import 'nodelist-foreach-polyfill';
import './_index.scss';
import "typeface-zilla-slab/files/zilla-slab-latin-300.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-300.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-300italic.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-300italic.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-400.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-400.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-400italic.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-400italic.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-500.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-500.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-500italic.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-500italic.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-600.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-600.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-600italic.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-600italic.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-700.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-700.woff2"; import "typeface-zilla-slab/files/zilla-slab-latin-700italic.woff"; import "typeface-zilla-slab/files/zilla-slab-latin-700italic.woff2";
import "typeface-nunito-sans/files/nunito-sans-latin-200.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-200.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-200italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-200italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-300.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-300.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-300italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-300italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-400.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-400.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-400italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-400italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-600.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-600.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-600italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-600italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-700.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-700.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-700italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-700italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-800.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-800.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-800italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-800italic.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-900.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-900.woff2"; import "typeface-nunito-sans/files/nunito-sans-latin-900italic.woff"; import "typeface-nunito-sans/files/nunito-sans-latin-900italic.woff2";
import $ from 'jquery';
import fitvids from 'fitvids';
import 'objectFitPolyfill';
import 'slick-carousel';
import Headroom from "headroom.js";

export { Foundation as Core }       from 'foundation-sites/js/foundation.core';
import * as CoreUtils               from 'foundation-sites/js/foundation.core.utils';
export { CoreUtils };
export { Box }                      from 'foundation-sites/js/foundation.util.box';
export { onImagesLoaded }           from 'foundation-sites/js/foundation.util.imageLoader';
export { Keyboard }                 from 'foundation-sites/js/foundation.util.keyboard';
export { MediaQuery }               from 'foundation-sites/js/foundation.util.mediaQuery';
export { Motion, Move }             from 'foundation-sites/js/foundation.util.motion';
export { Nest }                     from 'foundation-sites/js/foundation.util.nest';
export { Timer }                    from 'foundation-sites/js/foundation.util.timer';
export { Touch }                    from 'foundation-sites/js/foundation.util.touch';
export { Triggers }                 from 'foundation-sites/js/foundation.util.triggers';
export { Abide }                    from 'foundation-sites/js/foundation.abide';
export { Accordion }                from 'foundation-sites/js/foundation.accordion';
export { AccordionMenu }            from 'foundation-sites/js/foundation.accordionMenu';
export { Drilldown }                from 'foundation-sites/js/foundation.drilldown';
export { Dropdown }                 from 'foundation-sites/js/foundation.dropdown';
export { DropdownMenu }             from 'foundation-sites/js/foundation.dropdownMenu';
export { Equalizer }                from 'foundation-sites/js/foundation.equalizer';
export { Interchange }              from 'foundation-sites/js/foundation.interchange';
// export { Magellan }                 from 'foundation-sites/js/foundation.magellan';
export { OffCanvas }                from 'foundation-sites/js/foundation.offcanvas';
// export { Orbit }                    from 'foundation-sites/js/foundation.orbit';
export { ResponsiveMenu }           from 'foundation-sites/js/foundation.responsiveMenu';
export { ResponsiveToggle }         from 'foundation-sites/js/foundation.responsiveToggle';
export { Reveal }                   from 'foundation-sites/js/foundation.reveal';
// export { Slider }                   from 'foundation-sites/js/foundation.slider';
export { SmoothScroll }             from 'foundation-sites/js/foundation.smoothScroll';
export { Sticky }                   from 'foundation-sites/js/foundation.sticky';
export { Tabs }                     from 'foundation-sites/js/foundation.tabs';
export { Toggler }                  from 'foundation-sites/js/foundation.toggler';
export { Tooltip }                  from 'foundation-sites/js/foundation.tooltip';
export { ResponsiveAccordionTabs }  from 'foundation-sites/js/foundation.responsiveAccordionTabs';

export { Foundation }               from 'foundation-sites/js/entries/foundation';
export { default }                  from 'foundation-sites/js/entries/foundation';

import './menus/drilldown.js'; import './menus/meganav.js';

import './blocks/core-heading/heading';

import './global/fpo-logo.svg';

$(document).foundation();
fitvids();

$('.slick-three-up').on('setPosition', function( event ) {
    $(event.target).foundation('getHeights', function( heights ){
        $(event.target).foundation('applyHeight', heights);
    });
});

$('.slick-three-up').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    dots: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

var myElement = document.querySelector(".site-header");
// construct an instance of Headroom, passing the element

// initialise
var options = {
    // vertical offset in px before element is first unpinned
    offset : 50,
    tolerance : {
        up : 5,
        down : 0
    },
};

var headroom  = new Headroom(myElement, options);
headroom.init();

document.addEventListener('lazybeforeunveil', function(){
    window.objectFitPolyfill();
});




$('body')
    .on('opened.zf.offcanvas','#offCanvasRight', fixStickyElements)
    .on('closed.zf.offcanvas','#offCanvasRight', unfixStickyElements);

 function fixStickyElements() {
        const $el = $('.site-header');

        // If sticky element is currently fixed, adjust its top value to match absolute position due to transform scope
        // Limit to push transition because postion:fixed works without problems for overlap (no transform scope)
        if ($el.css('position') === 'fixed') {

            // Save current inline styling to restore it if undoing the absolute fixing
            let topVal = parseInt($el.css('top'), 10);
            $el.data('offCanvasSticky', { top: topVal });

            let absoluteTopVal = $(document).scrollTop() + topVal;
            $el.css({ top: `${absoluteTopVal}px`, width: '100%', transition: 'none' });
        }
}


function unfixStickyElements() {
        const $el = $('.site-header');
        let stickyData = $el.data('offCanvasSticky');


        // If sticky element has got data object with prior values (meaning it was originally fixed) restore these values once off-canvas is closed
        if (typeof stickyData === 'object') {
            setTimeout(function () {
                $el.css({top: `0px`, width: '', transition: ''});
                $el.data('offCanvasSticky', '');
            },1030);
        }
}
